<template>
  <router-view />
</template>

<script>
import Company from './config'
export default {
  created() {
    document.title = Company.title
  }
}
</script>
<style>
@import url("./assets/style/public.css");

/* Reset */
* {
  margin: 0;
  padding: 0;
}
div{
  transition: all .3s;
}

/* Element Plus tooltip/popper uses dynamic positioning; global transitions make it fly from the old position. */
.el-popper,
.el-popper *,
.el-tooltip__popper,
.el-tooltip__popper * {
  transition: none !important;
}
em,
i {
  font-style: normal;
}
li {
  list-style: none;
}
img {
  border: 0;
  vertical-align: middle;
}
button {
  cursor: pointer;
}
a {
  color: #666;
  text-decoration: none;
}
a:hover {
  color: #c81623;
}
/* Reset End */

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei,serif;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}

.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
</style>
